// Register ESC-key listener that calls onClose.
// Usage: useEscClose(onClose) inside every modal component.

import { useEffect } from 'react';

export function useEscClose(onClose: () => void) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
}
